import React from 'react';
import { useTranslation } from '../../I18n/Languages/LanguageContext';
import styles from './LanguageSwitcher.module.css';

const LanguageSwitcher = () => {
  const { language, changeLanguage } = useTranslation();

  return (
    <div className={styles.languageSwitcher}>
      <button 
        className={`${styles.langButton} ${language === 'al' ? styles.active : ''}`}
        onClick={() => changeLanguage('al')}
      >
        SQ
      </button>
      <button 
        className={`${styles.langButton} ${language === 'en' ? styles.active : ''}`}
        onClick={() => changeLanguage('en')}
      >
        EN
      </button>
    </div>
  );
};

export default LanguageSwitcher;